import ButtonLink from 'src/components/atoms/ButtonLink';
import { Icon } from 'src/components/atoms/Icon';
import TableCell from 'src/components/atoms/TableCell';
import { default as Tag, TagProps } from 'src/components/atoms/Tag';
import Text from 'src/components/atoms/Text';
import styled from 'styled-components/macro';

import {
  getResultStatusColorTag,
  getStatusColor,
  transformResultToReadable
} from 'src/features/fdeInbox/helpers';
import { EntryResultType, EntryStatusType } from 'src/ts/interfaces';

export const Header = styled.div`
  display: flex;
  padding-left: 5px;

  & > div {
    margin-right: 6rem;
    margin-bottom: 0.75rem;
  }

  & > div:last-child {
    margin-left: auto;
    margin-right: 0;
    justify-content: flex-end;
  }
`;

export const HeaderInfo = styled.div`
  display: flex;
  align-items: center;
  width: 180px;

  & > div {
    margin-right: 1rem;
  }

  & > h4 {
    color: ${({ theme }) => theme.color.gray[900]};
  }
`;

export const StyledText = styled(Text)`
  min-width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  display: inline;
`;

export const StyledButton = styled(ButtonLink)`
  justify-content: center;
  font-weight: 500;
  font-size: 0.875rem;
  gap: 0.75rem;
`;

export const StyledIcon = styled(Icon)`
  margin-left: 1rem;
`;

export const Content = styled.div`
  width: 100%;
  padding: 0 30px;

  .monthly-gross-income-tooltip {
    display: inline-flex;
    padding-left: 10px;
  }

  .align-download-button {
    display: inline-flex;
    vertical-align: middle;
  }

  .fde-table {
    overflow-x: visible;
  }
`;

export const ProofCount = styled.div`
  display: inline-flex;
`;
export const DocViewContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
  color: ${({ theme }) => theme.color.blue[700]};

  &[aria-disabled='true'] {
    cursor: unset;
    color: ${({ theme }) => theme.color.gray[300]};

    & > div > div > svg {
      fill: ${({ theme }) => theme.color.gray[300]};
    }
  }
`;

export const StatusLabelCell = styled(TableCell)<{ status: EntryStatusType }>`
  color: ${getStatusColor} !important;
`;

export const StyledTag = styled(Tag).attrs((props: TagProps) => ({
  label: transformResultToReadable(props.label as string),
  color: getResultStatusColorTag(props.label as EntryResultType),
  showBackground: true
}))``;

export const MonthlyGrossIncomeCell = styled.div`
  display: flex;
  align-items: center;
`;

export const ActionsTableCell = styled(TableCell)`
  position: relative;
  text-align: right;
  padding-right: 16px;
`;

export const ActionsHeaderCell = styled(TableCell)`
  text-align: right;
  padding-right: 16px;
`;

export const ActionsOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
`;

export const ActionsMenu = styled.div`
  position: absolute;
  right: 0;
  top: 100%;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 220px;
  z-index: 1000;
  margin-top: 4px;
`;

export const ActionsMenuItem = styled.button<{ disabled?: boolean; hasBorderTop?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 12px 16px;
  text-align: left;
  background: transparent;
  border: none;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  font-size: 14px;
  color: ${(props) => (props.disabled ? '#9ca3af' : '#374151')};
  transition: background-color 0.2s;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  border-top: ${(props) => (props.hasBorderTop ? '1px solid #e5e7eb' : 'none')};

  &:hover {
    background-color: ${(props) => (props.disabled ? 'transparent' : '#f3f4f6')};
  }
`;
